/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useForm } from 'react-hook-form';
import 'react-datepicker/dist/react-datepicker.css';
import './ModalForHprFilter.scss';
import { useDispatch, useSelector } from 'react-redux';
import { getAllPlantAndRegionNames } from '../../store/modules/newUser/actions';
import { selectAllPlantAndRegionNames } from '../../store/modules/newUser/selectors';
import Tooltip from '../Tooltip';

const ModalForHprFilter = ({
  show,
  toggle,
  onSubmit,
  values,
}) => {
  const dispatch = useDispatch();
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const startDate = new Date(year, 0, 1);
  const [fromDate, setFromDate] = useState(
    values ? new Date(values?.fromDate) : new Date(startDate.setMonth(startDate.getMonth(), 1)),
  );
  const [toDate, setToDate] = useState(values ? new Date(values?.toDate) : new Date());
  const [dateError, setDateError] = useState(null);
  const userRole = localStorage?.getItem('role');

  const plantCodeValues = useSelector((state) => selectAllPlantAndRegionNames(state)); // [{ regionName, plants: [{ plantName, plantCode }] }]
  const showHideClassName = show ? 'edit-user-modal display-block' : 'edit-user-modal display-none';

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  // Local state for dropdowns
  const [selectedRegion, setSelectedRegion] = useState('');
  const [filteredPlants, setFilteredPlants] = useState([]);

  // Fetch data
  const rolesToFetch = ['admin', 'regional_fa', 'regional_pi', 'ea_pi', 'call_center', 'plant_ic'];
  useEffect(() => {
    if (rolesToFetch.includes(userRole)) {
      dispatch(getAllPlantAndRegionNames());
    }
  }, []);

  // Update filtered plants when region changes
  useEffect(() => {
    if (selectedRegion && plantCodeValues?.length) {
      const regionData = plantCodeValues.find((r) => r.regionName === selectedRegion);
      setFilteredPlants(regionData ? regionData.plants : []);
    } else if (userRole !== 'admin') {
      // For non-admins, they have one region only
      const singleRegion = plantCodeValues?.[0];
      setFilteredPlants(singleRegion ? singleRegion.plants : []);
      setSelectedRegion(singleRegion?.regionName || '');
    }
  }, [selectedRegion, plantCodeValues]);

  const submit = ({
    plantCode,
    mobileNumber,
    vendorCode,
  }) => {
    toggle();
    onSubmit({
      regionName: selectedRegion,
      plantCode,
      mobileNumber,
      vendorCode,
      fromDate,
      toDate,
    });
  };

  return (
    <div className={showHideClassName}>
      <section className="modal-main">
        <div className="row">
          <div className="col-12 d-flex end">
            <button type="button" className="modal-main__button" onClick={toggle}>
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>

          <div className="col-12">
            <div className="form">
              <div className="row">

                {/* Region Dropdown (admin only) */}
                {userRole === 'admin' && (
                  <div className="col-12 col-md-6">
                    <div className="form__item">
                      <label htmlFor="regionName">
                        <div className="row middle">
                          <div className="col-12">
                            <span className="form__label">Region Name</span>
                          </div>
                          <div className="col-12">
                            <select
                              id="regionName"
                              name="regionName"
                              className="form__field"
                              value={selectedRegion}
                              onChange={(e) => setSelectedRegion(e.target.value)}
                            >
                              <option hidden value="">Choose Region</option>
                              {plantCodeValues?.map((region) => (
                                <option key={region.regionName} value={region.regionName}>
                                  {region.regionName}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </label>
                    </div>
                  </div>
                )}

                {/* Plant Name Dropdown (all roles, filtered) */}
                <div className="col-12 col-md-6">
                  <div className="form__item">
                    <label htmlFor="plantCode">
                      <div className="row middle">
                        <div className="col-12">
                          <span className="form__label">Plant Name</span>
                        </div>
                        <div className="col-12">
                          <select
                            id="plantCode"
                            name="plantCode"
                            className="form__field"
                            {...register('plantCode')}
                          >
                            <option hidden value="">Choose Plant</option>
                            {filteredPlants?.map((plant, idx) => (
                              <option key={plant.plantCode} value={plant.plantCode}>
                                {plant.plantName}
                              </option>
                            ))}
                          </select>
                          {errors.plantCode && (
                            <div className="form__error">{errors.plantCode.message}</div>
                          )}
                        </div>
                      </div>
                    </label>
                  </div>
                </div>

                {/* Mobile Number Input */}
                <div className="col-12 col-md-6">
                  <div className="form__item">
                    <label htmlFor="mobileNumber">
                      <div className="row middle">
                        <div className="col-12">
                          <span className="form__label">Mobile Number</span>
                        </div>
                        <div className="col-12">
                          <input
                            id="mobileNumber"
                            name="mobileNumber"
                            type="text"
                            className="form__field"
                            placeholder="Enter Mobile Number"
                            {...register('mobileNumber')}
                          />
                        </div>
                      </div>
                    </label>
                  </div>

                  {/* Vendor Code Input */}
                  <div className="form__item">
                    <label htmlFor="vendorCode">
                      <div className="row middle">
                        <div className="col-12">
                          <span className="form__label">Vendor Code</span>
                        </div>
                        <div className="col-12">
                          <input
                            id="vendorCode"
                            name="vendorCode"
                            type="text"
                            className="form__field"
                            placeholder="Enter Vendor Code"
                            {...register('vendorCode')}
                          />
                        </div>
                      </div>
                    </label>
                  </div>
                </div>

                {/* Date Filters */}
                <div className="col-12 col-md-6">
                  <div className="form__item">
                    <label htmlFor="fromDate">
                      <div className="row middle">
                        <div className="col-12">
                          <span className="form__label">
                            From Date
                            {' '}
                            <Tooltip
                              label={<FontAwesomeIcon icon={faCircleInfo} color="#bababa" size="xs" />}
                              hoverText="By default, the date is set at +3 months from the fiscal year."
                            />
                          </span>
                        </div>
                        <div className="col-12">
                          <DatePicker
                            selected={fromDate}
                            onChange={(date) => setFromDate(date)}
                            dateFormat="dd/MM/yyyy"
                            className="form__field"
                          />
                          {dateError && <div className="form__error">{dateError}</div>}
                        </div>
                      </div>
                    </label>
                  </div>

                  <div className="form__item">
                    <label htmlFor="toDate">
                      <div className="row middle">
                        <div className="col-12">
                          <span className="form__label">To Date</span>
                        </div>
                        <div className="col-12">
                          <DatePicker
                            selected={toDate}
                            onChange={(date) => setToDate(date)}
                            dateFormat="dd/MM/yyyy"
                            className="form__field"
                          />
                          {dateError && <div className="form__error">{dateError}</div>}
                        </div>
                      </div>
                    </label>
                  </div>
                </div>

                {/* Submit */}
                <div className="col-12">
                  <div className="form__item">
                    <div className="row">
                      <div className="col-12 d-flex-col middle">
                        <button
                          type="button"
                          className="form__button"
                          onClick={handleSubmit(submit)}
                        >
                          Filter
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ModalForHprFilter;
